import { HOME_PATH } from 'constants/paths'
import HomePage from './components/HomePage'

export default {
  path: HOME_PATH,
  component: HomePage
}
